import React from 'react'
import { IonAlert } from '@ionic/react'
import { useRouter } from '../resources/Hooks'

const ErrorBox = ({ alert, setAlert }) => {
    const route = useRouter()
    return (
        <>
            <IonAlert
                isOpen={alert}
                backdropDismiss={false}
                onDidDismiss={() => setAlert(false)}
                header={'Data not Available'}
                message={"The Bill / Ledger , you want to access is either deleted or available right now."}
                buttons={[
                    {
                        text: 'Ok',
                        handler: () => {
                            route.history.goBack();
                        }
                    }
                ]}
            />
        </>
    )
}

export default ErrorBox
